import { DatePipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BookingStatus, BookingStatusBadge, BookingStatusLabel } from '@views/common/models/booking-status.enum';
import { BadgeModule, BadgeTypeEnum, BadgeVariantEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/badge';
import {
  SortEvent,
  TableAlignHeaderEnum,
  TableConfig,
  TableModule
} from '@vueling-ng/vy-ds/src/lib/components/globals/table';
import { StateManagerService } from 'app/shared/state/state-manager.service';
import { TableItem } from 'app/views/booking-list/models/booking-table-data.interface';
import { internalRoutes } from 'environments/common/internal-routes';
import { MarkdownComponent } from 'ngx-markdown';
import { ChannelType } from '../../models/bookings.interface';

@Component({
  selector: 'app-booking-table',
  templateUrl: './booking-table.component.html',
  standalone: true,
  imports: [BadgeModule, TranslateModule, MarkdownComponent, TableModule, DatePipe]
})
export class BookingTableComponent {
  @Input()
  public tableConfig: TableConfig | undefined;

  @Output() public sort = new EventEmitter<SortEvent>();

  public TableAlignHeader = TableAlignHeaderEnum;

  public BadgeType = BadgeTypeEnum;
  public ChannelType = ChannelType;

  private readonly _router = inject(Router);
  private readonly _stateManagerService = inject(StateManagerService);

  public goToBookingDetails(recordLocator: string): void {
    this._stateManagerService.update((draft) => {
      draft.recordLocator = recordLocator;
    });
    void this._router.navigate([internalRoutes.BookingDetails]);
  }

  public getBookingStatusBadgeVariant(status: TableItem): BadgeVariantEnum {
    return BookingStatusBadge[status.row as BookingStatus];
  }

  public getBookingStatusBadgeLabel(status: TableItem): string {
    return BookingStatusLabel[status.row as BookingStatus];
  }

  public onSort(event: SortEvent): void {
    this.sort.emit(event);
  }
}
